<template>
    <div class="component-background component-background-mobile-deslogado min-h-screen h-full grid pb:grid-cols-2 gap-x-4 relative">
        <img src="/images/pessoas-home-deslogada-desktop.png" class="object-cover xl:max-w-[70vw] h-full sm:hidden -translate-y-16"/>
        <div class="flex flex-col pb:justify-center items-center max-w-[506px] mx-auto min-h-[90vh] sm:pt-20 sm:px-4 py-12 z-10">
            <div class="flex flex-col justify-center items-center">
                <img src="/images/slogan.png" class="w-full max-w-[300px] hidden sm:block"/>
                <img src="/images/logo.png" class="w-full"/>
            </div>
            <div class="pb:max-w-[310px] mt-14 sm:mt-24">
                <h1 class="text-3xl font-bold mb-2 text-hover sm:text-white">Saudações</h1>
                <p class="text-lg text-white">Ficamos muitos feliz que agora você faz parte da campanha <strong class="text-hover sm:text-white">VENÇA</strong>.</p>
                <p class="text-lg text-hover my-10 sm:text-white font-bold">Este será o seu ponto de partida para uma jornada incrível</p>
                <Button @click="submit">Explorar</button>
            </div>
        </div>
        <div class="absolute w-full bottom-0 flex justify-center">
            <div class="bg-secondary h-6 w-10/12 rounded-t-3xl"></div>
        </div>
    </div>
</template>
<script>
import ApplicationSlogan from "@/Components/ApplicationSlogan.vue";
import Button from "@/Components/Button.vue";
import Heading from '@/Components/UI/Texts/Heading.vue';
import RegisterLayout from "@/Layouts/Register.vue";

export default {
    components: {
        ApplicationSlogan,
        Heading,
        RegisterLayout,
        Button
    },
    data() {
        return {
            form: this.$inertia.form({
                cpf: sessionStorage.getItem("email"),
                password: sessionStorage.getItem("password")
            }),
            nomeDoProjeto : "Vença",
        }
    },
    methods: {
        submit() {
            // console.log(this.form);
            this.$inertia.post(this.route("login"), this.form, {
                onSuccess: () => {
                    sessionStorage.clear();
                }
            });
            // sessionStorage.clear();
        }
    }
}
</script>
